import { SCHEDULE_COLUMN_KEY } from '@app/pages/MonitoringLaunchPage/constants'

import type { Column, ColumnGroup } from '@app/components/base/Table/types'
import type { CommonColumnsScheduleData } from './types'

export const getScheduleColumnChildren = <DataSourceType extends { key: number }>(
  columns: Array<Column<DataSourceType>>
): Array<Column<CommonColumnsScheduleData>> | undefined => {
  const scheduleColumn = columns.find(column => column.key === SCHEDULE_COLUMN_KEY) as
    | ColumnGroup<CommonColumnsScheduleData>
    | undefined
  return scheduleColumn?.children
}
